<template>
  <div v-show="isCardActiveLocal">
    <course-viewer-quiz :isCardActive="doneLoading"
                        :quiz="quizDataNew"
                        :cardHeight="backgroundCardHeight"
                        :cardWidth="backgroundCardWidth"
                        :uuid="uuid"
                        @finishQuiz="quizFinished"
                        :key="index"
                        :isStudentProp="true"/>
  </div>
</template>
<script>
  import courseViewerQuiz from '../courseviewer/CourseViewerQuiz.vue';
  import { uuid } from 'vue-uuid';

  export default {
    components: {
      courseViewerQuiz,
      uuid
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      quizProp: {
        type: Object,
        required: true
      },
      popupXBtnClicked: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        backgroundCardHeight: "",
        backgroundCardWidth: "",
        uuid: "",
        quiz: {},
        logData: {},
        index: 0,
        isQuizFinished: false,
        quizDataNew:{},
        doneLoading:false
      }
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          self.isQuizFinished = false;
          self.showQuiz();
          self.resizeCard();
          self.index++;
        }else{
          this.$store.dispatch("updateTheme", "dark");
        }
      },
      popupXBtnClicked: function(val) {
        var self = this;
        if(val && !self.isQuizFinished) {
          var payload = {
            logIdentifier: self.uuid,
            toTaskId: null,
            fromTaskId: null,
            taskId: self.quizProp.id
          };

          self.$emit("postEndLog", payload);
        }
        else if(val && self.isQuizFinished) {
          self.$emit("refreshTasks");
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive && this.quizDataNew
        },
        set(val) {
          if (!val) {
            
          }
        }
      }
    },
    methods: {
      showQuiz() {
        var self = this;
        self.isQuizFinished = false;
        

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.quizProp.id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = null;
          self.logData.toTaskId = null;

          var onSuccess = function (response) {
            self.quiz
            var temp = response.data;
            self.quizDataNew = {...response.data, ...self.quiz}
            self.quizDataNew.questions = temp.questions
            if (self.quizDataNew) {
            //Check if on mobile
            if (self.isMobile() && self.quizDataNew.isDecisive) {
              self.$vs.dialog({
                type: "confirm",
                color: "warning",
                title: "Mobile Device Detected",
                text: "Unfortunately this quiz cannot be completed on a mobile device (smartphone or tablet).\n\nPlease log in again from a computer (laptop or desktop-computer).",
                accept: self.closePopup,
                acceptText: "Close",
                cancel: self.closePopup
              });
              return;
            }

            //Check if quiz is a Journal
            if (!self.quizDataNew.isJournal) {
              self.quizDataNew.questions.forEach(
                function(item) {
                  item.inputAnswer = null;
                  if (item.options) {
                    item.options.forEach(function(option) {
                      option.isSelected = null;
                    });
                  }
                }
              );
            }
            self.doneLoading = true;
          }}

          var payload = {
            logIdentifier: self.logData.logIdentifier,
            toTaskId: self.logData.fromTaskId,
            fromTaskId: self.logData.toTaskId,
            taskId: self.quizProp.id
          };

          self.$ajaxPost(self, "QuizTask/StartLogEntry", payload, onSuccess)

          self.quiz = self.quizProp;
      },
      resizeCard() {
        var ratio = 0.434;

        if ((window.innerWidth * 0.9) < 1555.55)
          this.backgroundCardWidth = window.innerWidth * 0.9;
        else
          this.backgroundCardWidth = 1555.55 * 0.9;

        this.backgroundCardHeight = this.backgroundCardWidth * ratio;
      },
      quizFinished(quizResults) {
        var self = this;
        if (quizResults) {
          self.logData.fromTaskId = null;
          self.logData.toTaskId = null;

          var onSuccess = function (response) {};

          var payload = {
            logIdentifier: self.logData.logIdentifier,
            toTaskId: self.logData.fromTaskId,
            fromTaskId: self.logData.toTaskId,
            taskId: self.quizProp.id
          };

          self.$ajaxPost(self, "QuizTask/EndLogEntry", payload, onSuccess);

          self.isQuizFinished = true;
        }
      },
      closePopup() {
        this.$emit("closePopup")
      }
    },
    mounted() {
      var self = this;
      self.$nextTick(() => {
        window.addEventListener("resize", () => {
          self.resizeCard();
        });
      });
    },
    created() {
      this.resizeCard();
    }
  }
</script>
<style lang="scss">
  #quizViewPopup div.vs-popup {
    width: 100%;
    height: 100%;

    .vs-popup--content {
      max-height: calc(100vh - 100px);

      
    }
  }

</style>